import { NavLink } from 'react-router-dom'

export default function SideNavbarItems({ to, label }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `mb-2 flex items-center gap-3 border-2 p-2 px-4 transition-all duration-300 ${
          isActive
            ? 'border-accent-500 text-accent-500'
            : 'border-transparent hover:border-accent-500 hover:text-accent-500'
        }`
      }
    >
      <span className="text-sm font-semibold md:inline">{label}</span>
    </NavLink>
  )
}
